export default (product, warehouseId) => {
  let makeable = null;
  let productWarehouseDetail = null;

  if (product.productWarehouseDetails) {
    productWarehouseDetail = product.productWarehouseDetails.find((pwd) => {
      return pwd.warehouse.id === warehouseId;
    });
  }

  if (productWarehouseDetail) {
    makeable = productWarehouseDetail.makeable !== null ? productWarehouseDetail.makeable : null;
  }

  return makeable;
};
